import { getOptionalQuestions } from '../../containers/checkout/utils';
import { CheckoutState } from '../../state';
import { getQuestionsForBuyer } from './buyer';

export const getOptionalQuestionsForBuyer = (state: CheckoutState) =>
    getOptionalQuestions(getQuestionsForBuyer(state));
